// action - account reducer
export const LOGIN = "@auth/LOGIN";
export const LOGOUT = "@auth/LOGOUT";
export const REGISTER = "@auth/REGISTER";
export const SET_KITE_CONNECT_STATUS = "SET_KITE_CONNECT_STATUS";
export const SET_SERVER_HEALTH_DATA = "SET_SERVER_HEALTH_DATA";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const TOGGLE_USER_LOGIN_STATUS = "TOGGLE_USER_LOGIN_STATUS";
export const TOGGLE_ORDER_STATUS = "TOGGLE_ORDER_STATUS";
export const SET_ORDER_PNL = "SET_ORDER_PNL";
